export default __webpack_public_path__ + "fm_og_share_white.png?ca81413396ad171b754717b97bb087f4";